import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { site } from "../../data/site";
import { Reveal } from "../ui/Reveal";

const audiences = [
  { label: "Customer support", detail: "Help with bookings, orders and accounts" },
  { label: "Business support", detail: "Help with listings, events and team access" },
  { label: "Partnerships and press", detail: "Business proposals and media enquiries" },
];

export function ContactClose() {
  return (
    <section id="contact" className="contact-close page-container">
      <Reveal className="contact-panel">
        <div className="contact-copy">
          <span className="eyebrow light">Contact</span>
          <h2>
            Contact the{" "}
            <br />
            <span>Stratify team.</span>
          </h2>
          <p>
            Email <a href={`mailto:${site.email}`}>{site.email}</a> for product
            support, business enquiries, or partnerships.
          </p>
          <Link to="/contact" className="text-link light">
            View contact details <ArrowUpRight size={15} />
          </Link>
        </div>
        <ul className="contact-audiences">
          {audiences.map((audience) => (
            <li key={audience.label}>
              <a
                href={`mailto:${site.email}?subject=${encodeURIComponent(audience.label)}`}
              >
                <span>
                  <strong>{audience.label}</strong>
                  <small>{audience.detail}</small>
                </span>
                <ArrowUpRight size={16} />
              </a>
            </li>
          ))}
        </ul>
      </Reveal>
    </section>
  );
}
